export default __webpack_public_path__ + "static/203-db28be88e4948c8b925a9672d0176a05.jpg";